import React from 'react'

import ModalV4 from "../../../../app/ui/modal/v4/v4"
import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top"
import ProjectUserIcon from "./components/project-user-icon/project-user-icon"
import UI5MenuItem from "../../../gd-components/menu/ui5-menu/ui5-menu-item"
import ModalUserDefault from "./components/views/default-view"
import ModalProjectUserActions from "./actions/actions"
import ReassignUserView from "./components/views/reassign-user-view"
import {ReassignmentDataType, USER_VIEW_TYPE} from "../@type";
import ProjectUserFull from "../../../model2/project-user/project-user-full";
import ProjectUsersFullCollection from "../../../model2/project-user/collection-full";
import UserAssignment_Collection from "../model/collection";

type Props = {
    params: {
        projectUser     : ProjectUserFull
        projectUsers    : ProjectUsersFullCollection
        // reassignResult  : ReassignmentDataType
        userAssignments : UserAssignment_Collection | null
        viewType        : USER_VIEW_TYPE
        onReassignDone  : callback
        onChange        : callback
    }
}

export default class ModalUserView extends ModalV4 {

    private actions: ModalProjectUserActions

    constructor(props: Props) {
        super(props);

        this.state = {
            view                : this.props.params.viewType,
            userAssignments     : this.props.params.userAssignments,
            reassignCallback    : null
        }

        this.actions = new ModalProjectUserActions(this.props.params, this.update, this.reassignItems, this.closeModal)

        // if (this.props.params.userAssignments.isEmpty) {
        //     this.actions.onReassignDone = this.props.params.onReassignDone
        // }
    }

    update = (callback: callback) => {this.forceUpdate(callback)}

    onCancel = () => {
        this.setState({
            view: USER_VIEW_TYPE.DEFAULT
        });
    }

    reassignItems = (view: USER_VIEW_TYPE, userAssignments?: UserAssignment_Collection | null) => {
        this.setState({
            view            : view,
            userAssignments : userAssignments
        })
    }

    renderViewContent() {

        const title = gd.spaces.workspaces.getByProjectId(this.props.params.projectUser.projectId) ? 'Workspace user' : 'Project user'

        const  menuItemAccess = {
            id          : 'default',
            icon        : 'ii5-information',
            label       : 'Project access',
            onClick     : this.onCancel
        }

        const  menuItemDelete = {
            id          : 'delete',
            icon        : 'i5-trash-alt',
            label       : 'Delete user',
            className   : "red",
            onClick     : this.actions.onDeleteConfirmed
        }

        switch (this.state.view) {

            // Eto teper v New reassign modal

            // case USER_VIEW_TYPE.CONFIRM:
            //     return (
            //         <div className="v4-container placement-middle ui5-iv view-project-user"
            //              onClick={this.stopPropagation}>
            //
            //             <ItemViewTop title={title} onCloseClick={this.closeModal}/>
            //
            //             <div className="iv-left-column">
            //                 <ProjectUserIcon projectId  = {this.props.params.projectUser.projectId}
            //                                  userId     = {this.props.params.projectUser.userId}/>
            //
            //                 <div className="ui5-menu p-t-0">
            //                     <UI5MenuItem item={menuItemAccess} selectedId={this.state.view}/>
            //                     {this.props.params.projectUser.acl.canDelete &&
            //                         <UI5MenuItem item={menuItemDelete} selectedId={this.state.view}/>
            //                     }
            //                 </div>
            //             </div>
            //             <ModalUserConfirm projectUser       = {this.props.params.projectUser}
            //                               reasonCantDelete  = {this.state.reasonCantDelete}
            //                               onCancel          = {this.onCancel}/>
            //         </div>
            //     )

            case USER_VIEW_TYPE.REASSIGN_ACCESS:
            case USER_VIEW_TYPE.REASSIGN_DELETE:
                return (
                    <div className  = "v4-container placement-middle ui5-iv w-650"
                         style      = {{height: 785}}
                         onClick    = {this.stopPropagation}>
                        <ReassignUserView reassignType      = {this.state.view}
                                          projectUser       = {this.props.params.projectUser}
                                          userAssignments   = {this.state.userAssignments}
                                          reasonCantDelete  = {this.state.reasonCantDelete}
                                          actions           = {this.actions}
                                          onCloseModal      = {this.closeModal}/>
                    </div>
                )

            default:
                return (
                    <div className="v4-container placement-middle ui5-iv view-project-user"
                         onClick={this.stopPropagation}>

                        <ItemViewTop title={title} onCloseClick={this.closeModal}/>

                        <div className="iv-left-column">
                            <ProjectUserIcon projectId={this.props.params.projectUser.projectId}
                                             userId={this.props.params.projectUser.userId}/>

                            <div className="ui5-menu p-t-0">
                                <UI5MenuItem item={menuItemAccess} selectedId={this.state.view}/>
                                {this.props.params.projectUser.acl.canDelete &&
                                    <UI5MenuItem item={menuItemDelete} selectedId={this.state.view}/>
                                }

                            </div>
                        </div>
                        <ModalUserDefault projectUser={this.props.params.projectUser}
                                          projectUsers={this.props.params.projectUsers}
                                          actions={this.actions}/>
                    </div>
                )
        }
    }

    render() {
        return this.renderViewContent()
    }
}
